export const spacersSizeMap = {
    nano: 2,
    micro: 4,
    mini: 8,
    small: 12,
    base: 16,
    medium: 20,
    large: 24,
    huge: 32,
    giant: 36,
    epic: 48,
};
